<template>
  <div id="app" :class="{ loading: !this.$store.getters.getReady, loaded: this.$store.getters.getReady }">
    <div class="loading-dots-wrapper" v-if="!this.$store.getters.getReady || this.$store.getters.getLoading">
      <div class="loading-dots centered">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="inner">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#app {
  position: relative;
  min-height: 100%; /* For full-page loading animation */
  background-image: url('./assets/1003-background.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  > .inner {
    opacity: 0;
    transition: opacity 1s;
    pointer-events: none;
  }
  &.loaded {
    > .inner {
      opacity: 1;
      pointer-events: auto;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
    overflow: hidden;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
}
</style>
